"use strict";
exports.__esModule = true;
var utils_1 = require("./utils");
exports["default"] = {
    please_select_time: function () { return "请选择时间"; },
    start_time: function () { return "开始时间"; },
    end_time: function () { return "结束时间"; },
    hour: function () { return "小时"; },
    minute: function () { return "分钟"; },
    second: function () { return "秒"; },
    duration: {
        hour: function (_d) { var d = (0, utils_1.reqArgs)(["amount"], _d); return " " + d.amount + " 小时"; },
        minute: function (_d) { var d = (0, utils_1.reqArgs)(["amount"], _d); return " " + d.amount + " 分钟"; },
        second: function (_d) { var d = (0, utils_1.reqArgs)(["amount"], _d); return " " + d.amount + " 秒"; }
    },
    dayNamesMin: {
        Su: function () { return "日"; },
        Mo: function () { return "一"; },
        Tu: function () { return "二"; },
        We: function () { return "三"; },
        Th: function () { return "四"; },
        Fr: function () { return "五"; },
        Sa: function () { return "六"; }
    },
    weekNamesMin: {
        Su: function () { return "周日"; },
        Mo: function () { return "周一"; },
        Tu: function () { return "周二"; },
        We: function () { return "周三"; },
        Th: function () { return "周四"; },
        Fr: function () { return "周五"; },
        Sa: function () { return "周六"; }
    },
    monthNamesShort: {
        Jan: function () { return "1月"; },
        Feb: function () { return "2月"; },
        Mar: function () { return "3月"; },
        Apr: function () { return "4月"; },
        May: function () { return "5月"; },
        Jun: function () { return "6月"; },
        Jul: function () { return "7月"; },
        Aug: function () { return "8月"; },
        Sep: function () { return "9月"; },
        Oct: function () { return "10月"; },
        Nov: function () { return "11月"; },
        Dec: function () { return "12月"; }
    },
    ok: function () { return "确定"; },
    now: function () { return "此刻"; },
    today: function () { return "今天"; },
    day: function () { return "日"; },
    weekHeader: function () { return "周"; },
    month: function () { return "月"; },
    year: function () { return "年"; },
    schedule: function () { return "日程"; },
    allDay: function () { return "全天"; },
    monthNames: {
        January: function () { return "1月"; },
        February: function () { return "2月"; },
        March: function () { return "3月"; },
        April: function () { return "4月"; },
        May: function () { return "5月"; },
        June: function () { return "6月"; },
        July: function () { return "7月"; },
        August: function () { return "8月"; },
        September: function () { return "9月"; },
        October: function () { return "10月"; },
        November: function () { return "11月"; },
        December: function () { return "12月"; }
    },
    startsWith: function () { return "开始于"; },
    endsWith: function () { return "结束于"; },
    edit: function () { return "编辑"; },
    confirm: function () { return "确认"; },
    cancel: function () { return "取消"; },
    collapse_sidebar: function () { return "收起侧边栏"; },
    expand_sidebar: function () { return "展开侧边栏"; },
    expand: function () { return "展开"; },
    collapse: function () { return "收起"; },
    no_data: function () { return "暂无数据"; },
    all_results_total: function (_d) { var d = (0, utils_1.reqArgs)(["count"], _d); return "共 " + d.count + " 条结果"; },
    per_page_item: function (_d) { var d = (0, utils_1.reqArgs)(["count"], _d); return "每页 " + d.count + " 条"; },
    item: function (_d) { var d = (0, utils_1.reqArgs)(["count"], _d); return d.count + "条"; },
    go_to_page: function (_d) { var d = (0, utils_1.reqArgs)(["number"], _d); return "前往 " + d.number + " 页"; },
    select_all: function () { return "全选"; },
    clear: function () { return "清除"; },
    reset: function () { return "重置"; },
    please_enter: function () { return "请输入"; },
    input_placeholder: function (_d) { var d = (0, utils_1.reqArgs)(["context"], _d); return "请输入" + d.context; },
    phone_invalid: function () { return "手机号格式错误"; },
    phone: function () { return "手机号"; },
    please_select: function () { return "请选择"; },
    upload_file: function () { return "上传文件"; },
    upload_again: function () { return "重新上传"; },
    uploading: function () { return "上传中"; },
    upload_successful: function () { return "上传成功"; },
    upload_failed: function () { return "上传失败"; },
    click_upload: function () { return "点击上传"; },
    drag_upload: function () { return "拖拽到此区域上传"; },
    more_filters: function () { return "更多标签"; },
    empty: function () { return "清空"; },
    more: function () { return "更多"; },
    more_labels: function () { return "更多筛选"; },
    selected_items: function (_d) { var d = (0, utils_1.reqArgs)(["count"], _d); return "已选中 " + d.count + " 项"; },
    password_placeholder: function () { return "请输入密码"; },
    preStep: function () { return "上一步"; },
    nextStep: function () { return "下一步"; },
    formMessage: function (_d) { var d = (0, utils_1.reqArgs)(["content"], _d); return d.content + "个错误"; },
    upload_manager: {
        title: {
            in_progress: function () { return "上传中"; },
            task_cancal: function () { return "任务取消"; },
            single: {
                succeeded: function () { return "上传成功"; },
                failed: function () { return "上传失败"; }
            },
            multiple: {
                all_succeeded: function () { return "全部上传成功"; },
                all_failed: function () { return "全部上传失败"; },
                partial_fail: function () { return "部分上传失败"; },
                succeed: function () { return "上传成功"; },
                failed: function () { return "上传失败"; }
            }
        },
        actions: {
            cancel: function () { return "取消上传"; },
            cancel_all: function () { return "全部取消"; },
            retry: function () { return "重新上传"; },
            error_and_retry: function () { return "网络错误，重新上传"; },
            retry_all: function () { return "全部重试"; }
        },
        messages: {
            cancelled: function () { return "上传取消"; },
            estimated_upload_time: function (_d) { var d = (0, utils_1.reqArgs)(["time"], _d); return "预计上传用时" + d.time; },
            files_in_progress: function (_d) { var d = (0, utils_1.reqArgs)(["count"], _d); return d.count + " 个文件正在上传"; },
            files_failed: function (_d) { var d = (0, utils_1.reqArgs)(["count"], _d); return d.count + " 个文件上传失败"; },
            files_succeeded: function (_d) { var d = (0, utils_1.reqArgs)(["count"], _d); return "已上传 " + d.count + " 个文件"; },
            has_identical_files: function () { return "检测到目录中含相同内容文件"; }
        }
    },
    download_manager: {
        title: {
            in_progress: function () { return "下载中"; },
            task_cancal: function () { return "任务取消"; },
            single: {
                succeeded: function () { return "下载成功"; },
                failed: function () { return "下载失败"; }
            },
            multiple: {
                all_succeeded: function () { return "全部下载成功"; },
                all_failed: function () { return "全部下载失败"; },
                partial_fail: function () { return "部分下载失败"; },
                succeed: function () { return "下载成功"; },
                failed: function () { return "下载失败"; }
            }
        },
        actions: {
            cancel: function () { return "取消下载"; },
            cancel_all: function () { return "全部取消"; },
            retry: function () { return "重新下载"; },
            error_and_retry: function () { return "网络错误，重新下载"; },
            retry_all: function () { return "全部重试"; }
        },
        messages: {
            pending: function () { return "等待下载..."; },
            cancelled: function () { return "下载取消"; },
            estimated_download_time: function (_d) { var d = (0, utils_1.reqArgs)(["time"], _d); return "预计下载用时" + d.time; },
            files_in_progress: function (_d) { var d = (0, utils_1.reqArgs)(["count"], _d); return d.count + " 个文件正在下载"; },
            files_failed: function (_d) { var d = (0, utils_1.reqArgs)(["count"], _d); return d.count + " 个文件下载失败"; },
            files_succeeded: function (_d) { var d = (0, utils_1.reqArgs)(["count"], _d); return "已下载 " + d.count + " 个文件"; },
            has_identical_files: function () { return "检测到目录中含相同内容文件"; }
        }
    },
    emptyMessage: function () { return "无选项"; },
    emptyMatchedMessage: function () { return "无匹配数据"; },
    emptyFilterMessage: function () { return "查询结果为空"; },
    pleaseEnterSearchContent: function () { return "请输入查询内容"; },
    region: {
        China: function () { return "中国"; },
        HongKong: function () { return "香港"; },
        Macao: function () { return "澳门"; },
        Taiwan: function () { return "台湾"; },
        America: function () { return "美国"; },
        Australia: function () { return "澳大利亚"; },
        Singapore: function () { return "新加坡"; }
    }
};
